import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilteredItemLocationsQueryVariables = Types.Exact<{
  filter: Types.ItemLocationFilterInput;
  search_term: Types.Scalars['String'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
  type?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetFilteredItemLocationsQuery = { __typename?: 'Query', getFilteredItemLocations: { __typename?: 'GetFilteredItemLocationsResponse', total: number, item_locations: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_account_id?: string | null, type?: string | null }> } };


export const GetFilteredItemLocationsDocument = gql`
    query GetFilteredItemLocations($filter: ItemLocationFilterInput!, $search_term: String!, $skip: Int!, $take: Int!, $type: String) {
  getFilteredItemLocations(
    filter: $filter
    search_term: $search_term
    take: $take
    skip: $skip
    type: $type
  ) {
    total
    item_locations {
      id
      name
      event_account_id
      type
    }
  }
}
    `;

/**
 * __useGetFilteredItemLocationsQuery__
 *
 * To run a query within a React component, call `useGetFilteredItemLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredItemLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredItemLocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search_term: // value for 'search_term'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetFilteredItemLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredItemLocationsQuery, GetFilteredItemLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredItemLocationsQuery, GetFilteredItemLocationsQueryVariables>(GetFilteredItemLocationsDocument, options);
      }
export function useGetFilteredItemLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredItemLocationsQuery, GetFilteredItemLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredItemLocationsQuery, GetFilteredItemLocationsQueryVariables>(GetFilteredItemLocationsDocument, options);
        }
export type GetFilteredItemLocationsQueryHookResult = ReturnType<typeof useGetFilteredItemLocationsQuery>;
export type GetFilteredItemLocationsLazyQueryHookResult = ReturnType<typeof useGetFilteredItemLocationsLazyQuery>;
export type GetFilteredItemLocationsQueryResult = Apollo.QueryResult<GetFilteredItemLocationsQuery, GetFilteredItemLocationsQueryVariables>;